// extracted by mini-css-extract-plugin
export default {"paginationPageDropdownWrap":"InvoiceToolbar_paginationPageDropdownWrap__unQj3","invoiceToolbar":"InvoiceToolbar_invoiceToolbar__VV8Gn"};